import { render } from "./DictField.vue?vue&type=template&id=f96fecfe&scoped=true&ts=true"
import script from "./DictField.vue?vue&type=script&lang=ts"
export * from "./DictField.vue?vue&type=script&lang=ts"

import "./DictField.vue?vue&type=style&index=0&id=f96fecfe&lang=scss&scoped=true"

import exportComponent from "/builds/arkindex/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f96fecfe"]])

export default __exports__